export const LOGIN_UNIQUE_ID_QUERY_PARAM = 'login_unique_id';

const LEGACY_SLUG_PATTERNS = [
  /\/dashboard\/command-cent(?:er|re)\/([^/?#]+)/i,
  /\/dashboard\/login\/([^/?#]+)/i,
  /\/login\/([^/?#]+)/i,
] as const;

export const getLoginUniqueId = (
  pathname: string = window.location.pathname,
  search: string = window.location.search
): string | null => {
  const params = new URLSearchParams(search);
  const fromQuery = params.get(LOGIN_UNIQUE_ID_QUERY_PARAM);
  if (fromQuery) {
    return fromQuery;
  }

  for (const pattern of LEGACY_SLUG_PATTERNS) {
    const match = pathname.match(pattern);
    if (match?.[1]) {
      return decodeURIComponent(match[1]);
    }
  }

  return null;
};

export const buildPathWithSlug = (
  basePath: string,
  loginUniqueId?: string | null,
  search?: string
): string => {
  const params = new URLSearchParams(search || '');
  if (loginUniqueId) {
    params.set(LOGIN_UNIQUE_ID_QUERY_PARAM, loginUniqueId);
  } else {
    params.delete(LOGIN_UNIQUE_ID_QUERY_PARAM);
  }

  const query = params.toString();
  return query ? `${basePath}?${query}` : basePath;
};

export const buildCommandCenterPath = (loginUniqueId?: string | null, search?: string): string => {
  return buildPathWithSlug('/', loginUniqueId, search);
};

export const buildLoginPath = (loginUniqueId?: string | null, search?: string): string => {
  return buildPathWithSlug('/login', loginUniqueId, search);
};
